module.exports = __webpack_public_path__ + "static/media/notify-member.7875cb91.svg";